import { PAYMENT_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { IPaymentWalletTransactionData, IPaymentWalletTransactionResponse } from "@/api_framework/api_modals/payment";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };

export const usePaymentWalletTransactionAPI = () => {
  const configuration = useConfiguration();
  const [walletTransaction, setWalletTransaction] = useState<IPaymentWalletTransactionData[]>([]);
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  // isCustomerWalletTableInProgress
  const execute = useCallback(
    async (customerId: string) => {
      try {
        dispatch(
          setLoading({
            key: "isCustomerWalletTableInProgress",
            status: true,
          }),
        );
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .get(`${PAYMENT_MODULE?.USER_WALLET?.baseURL}transactions/${customerId}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IPaymentWalletTransactionResponse>) => {
            if (res.data.status === true) {
              setWalletTransaction(res.data.data);
              dispatch(
                setLoading({
                  key: "isCustomerWalletTableInProgress",
                  status: false,
                }),
              );
              return { status: true, message: "Cart Level Coupons Fetched" };
            } else {
              dispatch(
                setLoading({
                  key: "isCustomerWalletTableInProgress",
                  status: false,
                }),
              );
              setWalletTransaction([]);

              return { status: false, message: "No Cart Level Coupons" };
            }
          })
          .catch((e: AxiosError) => {
            setWalletTransaction([]);
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(
              setLoading({
                key: "isCustomerWalletTableInProgress",
                status: false,
              }),
            );
            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e: any) {
        dispatch(
          setLoading({
            key: "isCustomerWalletTableInProgress",
            status: false,
          }),
        );
        setWalletTransaction([]);
        captureError(e);
      }
    },
    [dispatch],
  );
  return { walletTransaction, execute };
};
